/* =============================================
   PROMO CODE FIELD — Sense Theme
   Redirect strategy: /checkout?discount=COD
   ============================================= */

(function () {
  'use strict';

  // ── Constante ──
  var STORAGE_KEY = 'promo_code_pending';

  function PromoCodeField(wrapper) {
    this.wrapper = wrapper;
    this.toggle  = wrapper.querySelector('[data-promo-toggle]');
    this.field   = wrapper.querySelector('[data-promo-field]');
    this.input   = wrapper.querySelector('[data-promo-input]');
    this.btn     = wrapper.querySelector('[data-promo-btn]');
    this.message = wrapper.querySelector('[data-promo-message]');

    if (!this.toggle || !this.field || !this.input || !this.btn) return;

    this._bindEvents();
    this._restoreSavedCode();
  }

  PromoCodeField.prototype._bindEvents = function () {
    var self = this;

// ── IMPORTANT: oprește propagarea click-urilor spre body ──
  this.wrapper.addEventListener('click', function (e) {
    e.stopPropagation();
  });

    // Toggle expand
    this.toggle.addEventListener('click', function () {
      self._toggleField();
    });

    // Enter key pe input
    this.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        self._apply();
      }
    });

    // Auto uppercase
    this.input.addEventListener('input', function () {
      var pos = this.selectionStart;
      this.value = this.value.toUpperCase();
      try { this.setSelectionRange(pos, pos); } catch(e) {}
      // Șterge mesajul când userul modifică inputul
      self._clearMessage();
    });

    // Apply button
    this.btn.addEventListener('click', function () {
      self._apply();
    });
  };

  PromoCodeField.prototype._toggleField = function () {
    var isOpen = !this.field.hasAttribute('hidden');

    if (isOpen) {
      this.field.setAttribute('hidden', '');
      this.toggle.setAttribute('aria-expanded', 'false');
    } else {
      this.field.removeAttribute('hidden');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.input.focus();
    }
  };

  PromoCodeField.prototype._apply = function () {
    var code = this.input.value.trim();

    if (!code) {
      this._showMessage('Te rugăm introdu un cod de reducere.', 'error');
      this.input.focus();
      return;
    }

    this._setLoading(true);
    this._clearMessage();

    // Salvează codul în sessionStorage (util dacă redirect eșuează)
    try { sessionStorage.setItem(STORAGE_KEY, code); } catch(e) {}

    // Redirect la checkout cu discount pre-aplicat
    var self = this;
    this._showMessage('Cod aplicat! Redirecționăm...', 'success');

    setTimeout(function () {
      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    }, 700);
  };

  PromoCodeField.prototype._restoreSavedCode = function () {
    // Dacă există un cod salvat anterior (de ex. userul s-a întors din checkout)
    try {
      var saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved && !this.input.value) {
        this.input.value = saved;
      }
    } catch(e) {}
  };

  PromoCodeField.prototype._setLoading = function (state) {
    if (state) {
      this.btn.setAttribute('disabled', '');
      this.btn.setAttribute('data-loading', '');
      this.input.setAttribute('readonly', '');
    } else {
      this.btn.removeAttribute('disabled');
      this.btn.removeAttribute('data-loading');
      this.input.removeAttribute('readonly');
    }
  };

  PromoCodeField.prototype._showMessage = function (text, type) {
    this.message.textContent = text;
    this.message.setAttribute('data-visible', '');
    this.message.setAttribute('data-type', type);
  };

  PromoCodeField.prototype._clearMessage = function () {
    this.message.removeAttribute('data-visible');
    this.message.removeAttribute('data-type');
    this.message.textContent = '';
  };

  // ── Init toate instanțele ──
  function initAll() {
    document.querySelectorAll('[data-promo-wrapper]').forEach(function (el) {
      if (!el.dataset.promoReady) {
        el.dataset.promoReady = '1';
        new PromoCodeField(el);
      }
    });
  }

  // ── MutationObserver pentru drawer cart (injectat dinamic) ──
  function observeDrawer() {
    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutations) {
      var needsInit = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (
              node.matches('[data-promo-wrapper]') ||
              node.querySelector('[data-promo-wrapper]')
            ) {
              needsInit = true;
            }
          }
        });
      });
      if (needsInit) initAll();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Boot ──
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      observeDrawer();
    });
  } else {
    initAll();
    observeDrawer();
  }

})();